import { render, staticRenderFns } from "./bfhighlights.vue?vue&type=template&id=65e3dd24&scoped=true&"
import script from "./bfhighlights.vue?vue&type=script&lang=js&"
export * from "./bfhighlights.vue?vue&type=script&lang=js&"
import style0 from "./bfhighlights.vue?vue&type=style&index=0&id=65e3dd24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e3dd24",
  null
  
)

export default component.exports